import { createVNode as e, mergeProps as l } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DictionaryFilled.js";
import n from "../components/PfIcon.js";
const r = (t, i) => {
  const o = {
    ...t,
    ...i.attrs
  };
  return e(n, l(o, {
    icon: a
  }), null);
};
r.displayName = "DictionaryFilled";
r.inheritAttrs = !1;
export {
  r as default
};
